import { observer } from 'mobx-react';
import moment from 'moment';

import CommonStatus from 'constants/types/common-status';

//@ts-ignore
import { Button, Filter, InputSearch } from '@microui/react-ui';

function CustomFilter({
  initFilters = null,
  config = [
    {
      accessor: 'status',
      data: [
        {
          value: CommonStatus.ACTIVED,
          label: CommonStatus[CommonStatus.ACTIVED].label,
        },
        {
          value: CommonStatus.LOCKED,
          label: CommonStatus[CommonStatus.LOCKED].label,
        },
        {
          value: CommonStatus.INACTIVED,
          label: CommonStatus[CommonStatus.INACTIVED].label,
        },
      ],
      label: 'Trạng thái',
      type: 'select',
    },
    {
      accessor: 'fromDate',
      props: {
        formatString: 'YYYY/MM/DD',
        endDate: moment('toDate'),
      },
      label: 'Từ ngày',
      type: 'datepicker',
    },
    {
      accessor: 'toDate',
      props: {
        formatString: 'YYYY/MM/DD',
        startDate: moment('fromDate'),
      },
      label: 'Đến ngày',
      type: 'datepicker',
    },
  ],
  filterValues = null,
  onSetFilters = (any, boolean?) => {},
  onSearch = () => {},
  loading = false,
  showExtraFilter = true
}) {
  return (
    <div className="flex items-center gap-3">
      <InputSearch
        onChange={(e) => onSetFilters({ keyword: e })}
        value={filterValues?.keyword}
        onClear={() => onSetFilters({ keyword: initFilters?.keyword ?? '' })}
        className="w-[400px]"
        placeholder="Nhập từ khoá"
        onSearch={() => onSearch()}
      />

      <Button
        color="primary"
        type="primary"
        loading={loading}
        onClick={() => onSearch()}
      >
        Tìm kiếm
      </Button>

      {config.length > 0 && showExtraFilter && (
        <Filter
          configs={config}
          initialValue={initFilters}
          onSubmit={(value) => {
            onSetFilters(value);
            onSearch();
          }}
          onClear={() => {
            onSetFilters(initFilters, true);
            onSearch();
          }}
        />
      )}
    </div>
  );
}

export default observer(CustomFilter);
